import { getRequest, postRequestV2, putRequest } from 'api/apiUtils'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import UserActionTypes from '../user/user-types'
import {
    failureChange2FaAuthenticationType,
    set2FaType,
    startFetchGoogleAuthenticationTypes as startFetchGoogleAuthenticationTypesAction,
    successChange2FaAuthenticationType,
    successFetchGoogleAuthenticationTypes,
    successGoogleAuthenticationSetup,
} from './2FA-actions'
import { fetchDefaultTwoFactorAuthenticationType } from '../user/user-actions'
import TwoFActionTypes from './2FA-types'

function* signInSuccess({ payload: { defaultTwoFactorAuthenticationType } }) {
    try {
        yield put(set2FaType(defaultTwoFactorAuthenticationType))
        yield put(startFetchGoogleAuthenticationTypesAction())
    } catch {
        yield
    }
}

export function* onSignSuccess() {
    yield takeLatest(UserActionTypes.SIGN_IN_SUCCESS, signInSuccess)
}

function* startChange2FaAuthenticationType({ payload: data }) {
    try {
        yield putRequest('/user/security/twofactor/authentificationType', data)
        yield put(successChange2FaAuthenticationType())
        yield put(set2FaType(data.type))
        yield put(fetchDefaultTwoFactorAuthenticationType())
    } catch (err) {
        yield put(failureChange2FaAuthenticationType({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartChange2FaAuthenticationType() {
    yield takeLatest(TwoFActionTypes.START_CHANGE_2FA_AUTHENTICATION_TYPE, startChange2FaAuthenticationType)
}

export function* verifyGoogleAuthCode({ payload: { verificationCode, challenge, activateTypeTo } }) {
    try {
        yield postRequestV2('/user/security/two-factor/google-authenticator/setup/confirm', { verificationCode, challenge })
        yield put(successChange2FaAuthenticationType())
        yield put(set2FaType(activateTypeTo))
        yield put(fetchDefaultTwoFactorAuthenticationType())
    } catch (err) {
        yield put(failureChange2FaAuthenticationType({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartVerifyGoogleAuthCode() {
    yield takeLatest(TwoFActionTypes.VERIFY_GOOGLE_AUTH_CODE, verifyGoogleAuthCode)
}

function* startGoogleAuthenticationSetup({ payload: verificationCode }) {
    try {
        const { data } = yield postRequestV2('/user/security/two-factor/google-authenticator/setup', { verificationCode })
        yield put(successGoogleAuthenticationSetup(data))
    } catch (err) {
        yield put(failureChange2FaAuthenticationType({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartGoogleAuthenticationSetup() {
    yield takeLatest(TwoFActionTypes.START_GOOGLE_AUTHENTICATION_SETUP, startGoogleAuthenticationSetup)
}

function* startFetchGoogleAuthenticationTypes() {
    try {
        const { data } = yield getRequest('/user/security/twofactor/authenticationTypes')
        yield put(successFetchGoogleAuthenticationTypes(data))
    } catch (err) {
        yield
    }
}

export function* onStartFetchGoogleAuthenticationTypes() {
    yield takeLatest(TwoFActionTypes.START_FETCH_AUTHENTICATION_TYPES, startFetchGoogleAuthenticationTypes)
}

export function* twoFASagas() {
    yield all([call(onStartChange2FaAuthenticationType), call(onStartVerifyGoogleAuthCode), call(onStartGoogleAuthenticationSetup), call(onSignSuccess), call(onStartFetchGoogleAuthenticationTypes)])
}
